import React, { useState, useEffect } from "react";

const Typewriter = ({ texts = [], speed = 100, delay = 2000 }) => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!texts.length) return;

    if (subIndex === texts[index].length + 1 && !deleting) {
      const timeout = setTimeout(() => setDeleting(true), delay);
      return () => clearTimeout(timeout);
    }

    if (subIndex === 0 && deleting) {
      setDeleting(false);
      setIndex((prev) => (prev + 1) % texts.length);
      return;
    }

    const timeout = setTimeout(
      () => {
        setSubIndex((prev) => prev + (deleting ? -1 : 1));
      },
      deleting ? speed / 2 : speed
    );

    return () => clearTimeout(timeout);
  }, [subIndex, index, deleting, texts, speed, delay]);

  if (!texts.length) return null;

  return (
    <h4 style={{ fontFamily: "Open Sans" }}>
      {texts[index].substring(0, subIndex)}
      <span className="cursor">|</span>
    </h4>
  );
};

export default Typewriter;
